// extracted by mini-css-extract-plugin
export default {"testValueFormControl":"RegexTesterDialog-module__testValueFormControl--O7MmX"};